<template>
  <div :id="id" class="row">
    <div class="col-12">
      <div class="row align-items-center">
        <LmTextInput
        :id="`label-${id}`"
        ref="inputFocus"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
        />
        <LmTextInput
        v-if="validateSuperUser"
        :id="`nombre-${id}`"
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
        />
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('multiple')"
          v-model="component.componentProps.multiple"
          @input="$emit('input', component)"
        />
        <LmTextInput
          class="col-12 col-md-8"
          :id="id + 'help'"
          v-model="component.componentProps.help"
          @input="$emit('input', component)"
          :label="$t('helper_text_setter')"
          :placeholder="$t('helper_text_setter')"
          :help="$t('helper_text_setter_help')"
        />
        <LmSelect
          :id="id + 'css'"
          class="col-12 col-md-4"
          v-model="component.class"
          :options="{
            content: [
              {value: 'col-12 col-md-3',text: '25%'},
              {value: 'col-12 col-md-6', text: '50%'},
              {value: 'col-12 col-md-9', text: '75%'},
              {value: 'col-12 col-md-12', text: '100%'}
            ]
          }"
          :label="$t('desktop_view_width')"
          :help="$t('help_width_form_element')"
          @input="$emit('input', component)"
        />
      </div>
    </div>
    <div class="col-12">
      <h5>{{ $t('options') }}</h5>
        <LmSelect
          :id="id + 'children-of'"
          v-model="component.childrenOf"
          :options="optionsChildOf"
          :label="$t('depends_of')"
          :help="$t('help_rely_on_form_element')"
          @input="$emit('input', component)"
        />
        <LmSuperPowerSelectV2
          :options="options"
          :label="$t('data_origin')"
          v-model="component.componentProps.urlPathFromGetOptions"
          @input="setUrlPathFromGetOptions($event)"
        />
        <template v-if="!isManualOptionLoadDisabled">
          <div
            v-for="(option, index) in component.componentProps.options"
            :key="index"
            class="row align-items-center"
            >
            <LmTextInput
              :disabled="isManualOptionLoadDisabled"
              class="col-12 col-md-5"
              v-model="component.componentProps.options[index].name"
              @input="$emit('input', component)"
              :label="$t('text')"
              :placeholder="$t('text')"
            />
            <LmTextInput
              :disabled="isManualOptionLoadDisabled"
              class="col-12 col-md-5"
              v-model="component.componentProps.options[index].id"
              @input="$emit('input', component)"
              :label="$t('value')"
              :placeholder="$t('value')"
            />
            <font-awesome-icon
              v-if="isAtLeastOneOption"
              class="mt-3 col-12 col-md-1"
              :class="{clickable: !isManualOptionLoadDisabled, 'not-allowed': isManualOptionLoadDisabled}"
              icon="trash"
              @click="!isManualOptionLoadDisabled && removeOption(index)" />
          </div>
          <LmButton
            :disabled="isManualOptionLoadDisabled"
            type="button"
            :value="$t('add_option')"
            @click.native="addOption"
          />
        </template>
    </div>
    <div class="col-12">
      <LmSuperPowerSelectV2
        :multiple="component.componentProps.multiple"
        :disabled="!!component.childrenOf"
        :options="component.componentProps.options"
        :urlPathFromGetOptions="component.componentProps.urlPathFromGetOptions"
        :label="$t('default_value')"
        v-model="component.componentProps.defaultValue"
        @input="$emit('input', component)"
      />
    </div>
    <LmCheckbox
      class="col-12"
      v-model="component.componentProps.allOptionsSelectedByDefault"
      :labelSingle="$t('all_options_by_default')"
      @input="$emit('input', component)"
      v-if="componentData.componentProps.multiple"
      />
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      :self="component.formObjectToSendToServerProperty"
    />
    <LmConditionalByEditModeBuilderUi
      :component="component"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false
      }
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    optionsChildOf: {
      type: Object,
      default: () => ({ content: [] })
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    LmButton,
    LmSuperPowerSelectV2,
    LmCheckbox
  },
  computed: {
    isManualOptionLoadDisabled () {
      return !!this.component.componentProps.urlPathFromGetOptions || !!this.component.childrenOf
    },
    isAtLeastOneOption () {
      return this.component.componentProps.options.length > 1
    }
  },
  methods: {
    setUrlPathFromGetOptions (event) {
      if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_CODIFICATORS === 'yes') {
        this.component.componentProps.urlPathFromGetOptions = event?.path
      } else {
        this.component.componentProps.urlPathFromGetOptions = event?.name
      }
    },
    addOption () {
      this.component.componentProps.options.push({ value: '', text: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.options.splice(optionIndex, 1)
    }
  },
  watch: {
    'component.childrenOf' () {
      this.component.componentProps.disabled = !!this.component.childrenOf || false
    },
    componentData () {
      this.component = this.componentData
    }
  }
}
</script>
